import { defineMessages } from "react-intl";

export const messages = defineMessages({
  addOption: {
    id: "settings.customFields.createEditPane.options.addOption",
    defaultMessage: "Add option",
    description: "Settings Custom field - new cf Select field options - add option",
  },
  confirm: {
    id: "settings.customFields.createEditPane.options.delete.confirm",
    defaultMessage: "I’m sure",
    description: "Settings Custom field - new cf Select field options - delete popconfirm confirm",
  },
  dragAndDropTooltip: {
    id: "settings.customFields.createEditPane.options.dragAndDropTooltip",
    defaultMessage: "Drag and drop to reorder",
    description: "Title for drag and drop to reorder tooltip",
  },
  goBack: {
    id: "settings.customFields.createEditPane.options.delete.goBack",
    defaultMessage: "Go back",
    description: "Settings Custom field - new cf Select field options - delete popconfirm go back",
  },
  moveToBottomButton: {
    id: "settings.customFields.createEditPane.options.moveToBottomButton",
    defaultMessage: "Move to bottom",
    description: "Move to bottom button",
  },
  moveToTopButton: {
    id: "settings.customFields.createEditPane.options.moveToTopButton",
    defaultMessage: "Move to top",
    description: "Move to top button",
  },
  placeholder: {
    id: "settings.customFields.createEditPane.options.placeholder",
    defaultMessage: "Name this option",
    description: "Settings Custom field - new cf options placeholder",
  },
  popconfirmTitle: {
    id: "settings.customFields.createEditPane.options.delete.popconfirmTitle",
    defaultMessage:
      "Are you sure you want to delete this value? Any records that have this value will show this field as empty.",
    description: "Settings Custom field - new cf Select field options - delete popconfirm title",
  },
  popupDiscardButton: {
    id: "settings.customFields.createEditPane.options.abcSortConfirmation.cancel",
    defaultMessage: "No",
    description: "Discard button for popup",
  },
  popupYesButton: {
    id: "settings.customFields.createEditPane.options.abcSortConfirmation.ok",
    defaultMessage: "Yes",
    description: "Yes button for popup",
  },
  sortOption: {
    id: "settings.customFields.createEditPane.options.sortOption",
    defaultMessage: "Sort",
    description: "Settings Custom field - new cf Select field options - sort option",
  },
  sortPopConfirm: {
    id: "settings.customFields.createEditPane.options.abcSortConfirmation",
    defaultMessage: "Alphabetizing cannot be undone. Continue?",
    description: "Settings Custom field - new cf Select field options - sort pop confirm on click",
  },
  sortTooltip: {
    id: "settings.customFields.createEditPane.options.sortTooltip",
    defaultMessage: "Alphabetize options",
    description: "Sort button tooltip",
  },
  title: {
    id: "settings.customFields.createEditPane.options.title",
    defaultMessage: "Select field options",
    description: "Settings Custom field - new cf Select field options title",
  },
});
